import React from 'react';
import {Switch, Route} from 'react-router-dom';
import Meta from '../../../../model/Meta';

/* Steps */
import DefaultView from './DefaultView';
import DeedOfAbsoluteSaleStep1 from './DeedOfAbsoluteSaleStep1';
import DeedOfAbsoluteSaleStep2 from './DeedOfAbsoluteSaleStep2';
import DeedOfAbsoluteSaleStep3 from './DeedOfAbsoluteSaleStep3';
import DeedOfAbsoluteSaleStep4 from './DeedOfAbsoluteSaleStep4';
import DeedOfAbsoluteSaleStep5 from './DeedOfAbsoluteSaleStep5';
import DeedOfAbsoluteSaleStep6 from './DeedOfAbsoluteSaleStep6';
import Ty from './Ty';

const DeedOfAbsoluteSale = (props)=>{
    let basePath = "/contracts/real-estate/deed-of-absolute-sale";
    
    const meta = {
        title: "Deed of Absolute Sale Contract",
        description: "A Deed of Absolute Sale is a written agreement whereby the seller absolutely transfers, assigns and sells all his rights and interest over a real property to the buyer without any other conditions beyond the satisfaction of the purchase price. As such, it is the document commonly used in real estate sale transactions."
    }

	return (
		<div className="page page-inner page-contract">
            <Meta {...meta}/>
            <div className="container-fluid">
                <div className="p-0">
                    <div className="page-content py-3">

                        <Switch>
                            <Route path={basePath+"/1"} component={DeedOfAbsoluteSaleStep1} />
                            <Route path={basePath+"/2"} component={DeedOfAbsoluteSaleStep2} />
                            <Route path={basePath+"/3"} component={DeedOfAbsoluteSaleStep3} />
                            <Route path={basePath+"/4"} component={DeedOfAbsoluteSaleStep4} />
                            <Route path={basePath+"/5"} component={DeedOfAbsoluteSaleStep5} />
                            <Route path={basePath+"/6"} component={DeedOfAbsoluteSaleStep6} />
                            <Route path={basePath+"/ty"} component={Ty} />
                            <Route component={DefaultView} />
                        </Switch>

                    </div>
                </div>
            </div>
        </div>
	);
}

export default DeedOfAbsoluteSale;


// WEBPACK FOOTER //
// ./src/pages/contracts/real-estate/deed-of-absolute-sale/DeedOfAbsoluteSale.js